module.exports = __webpack_public_path__ + "static/media/event2.7e99dfec.jpg";